import type { ComponentProps } from 'react'

/** Generated from Penpot `icons / change direction V2`. Do not edit by hand. */
export function ChangeDirectionIcon(props: ComponentProps<'svg'>) {
  return (
    <svg viewBox="0 0 16 12.444" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M16,3.56L12.44,0L12.44,2.67L6.22,2.67L6.22,4.44L12.44,4.44L12.44,7.11M3.56,5.33L0,8.89L3.56,12.44L3.56,9.78L9.78,9.78L9.78,8L3.56,8Z" />
    </svg>
  )
}
